import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { BankAccountList } from "./BankAccountList";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class UpdateBankConfigurationCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(
    bank_account_id:string,
    company_id:Number,
    concatenate_concept:boolean,
    avoidDetectTransferBetweenAccounts:boolean,
    workWithEffects:boolean,
    default_effects_cuenta_ingresos:string,
    default_effects_cuenta_gastos:string,
    automatic_upload_transactions:boolean,
    automatic_apply_rules:boolean,
    activity_code:string,
    channel_code:string,
    department_id:string,
    excel_format:any
  ): Promise<any> {
    let args = {
      bank_account_id: bank_account_id,
      concatenate_concept: concatenate_concept,
      avoid_detect_transfer_between_accounts: avoidDetectTransferBetweenAccounts,
      work_with_effects: workWithEffects,
      default_effects_cuenta_ingresos: default_effects_cuenta_ingresos,
      default_effects_cuenta_gastos: default_effects_cuenta_gastos,
      automatic_upload_transactions: automatic_upload_transactions,
      automatic_apply_rules: automatic_apply_rules,
      activity_code: activity_code,
      channel_code: channel_code,
      department_id: department_id,
      excel_format: excel_format
    }
    this.frontend.loadingShowConfigurationPopUp = true
    await this.dispatcher.dispatch('update.bank.configuration', args)
    this.frontend.loadingShowConfigurationPopUp = false
    this.frontend.showConfigurationPopUp = false
    await new BankAccountList(this.q_dispatcher, this.frontend).run(company_id, bank_account_id)
  }
}